const RichTextKeys = {
  CONTENT: 'content',
  PRIVATE_INTERNAL_ID: 'privateInternalId',
  TYPE: 'type'
};
export default RichTextKeys;